import { TEMPLATE_STATUS } from '../constants/messageTemplateKeys';

const LIVE_STATUSES = [TEMPLATE_STATUS.PUBLISHED, TEMPLATE_STATUS.ACTIVE];

export function isLiveTemplateStatus(status) {
  return LIVE_STATUSES.includes(String(status ?? ''));
}
